import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import image1 from "./assets/image/1.jpg";
import image2 from "./assets/image/2.jpg";
import image3 from "./assets/image/3.jpg";
import { Helmet } from "react-helmet-async";

export default function HowItWorks() {
  return (
    <section className="how-it-works-section py-4">
      <Helmet>
        <title>How 9R NFC Cards Work | Customize & Connect Instantly</title>
        <meta
          name="description"
          content="Learn how 9R NFC Cards work. Customize your NFC card, link to a digital profile, and share instantly with NFC-enabled smartphones."
        />
        <meta
          name="keywords"
          content="9R NFC Card, NFC smart card, digital profile, contact sharing, NFC technology"
        />
      </Helmet>

      <Container>
        <h2 className="text-center section-title fw-semibold mb-md-4 mb-4">
          How 9R NFC Cards Work
        </h2>
        <Row className="text-center">
          <Col md={4} className="mb-md-0 mb-4 pb-lg-0 pb-2">
            <Image
              src={image1}
              alt="Customize Your 9R NFC Card with branding and logo"
              className="how-it-works-image mb-4"
              fluid
            />
            <h4 className="HowItWorkTextHeading">1. Customize Your 9R NFC Card</h4>
            <p className="HowItWorkTextDetails m-0">
              Use our online design tool or upload your details. We'll craft
              your personalized 9R NFC Smart Card, featuring your branding, logo,
              and style. A preview will be sent before final print.
            </p>
          </Col>
          <Col md={4} className="mb-md-0 mb-4 pb-lg-0 pb-2">
            <Image
              src={image2}
              alt="Link your 9R NFC Card to your digital profile"
              className="how-it-works-image mb-4"
              fluid
            />
            <h4 className="HowItWorkTextHeading">
              2. Link to Your 9R NFC Digital Profile
            </h4>
            <p className="HowItWorkTextDetails m-0">
              Every 9R NFC Card is linked to a secure online profile. Edit your
              contact details, links, and social handles anytime through your
              dashboard—no coding required.
            </p>
          </Col>
          <Col md={4} className="pb-lg-0 pb-2">
            <Image
              src={image3}
              alt="Tap to Share your 9R NFC Card's information instantly"
              className="how-it-works-image mb-4"
              fluid
            />
            <h4 className="HowItWorkTextHeading">3. Tap & Connect Instantly</h4>
            <p className="HowItWorkTextDetails m-0">
              Just tap your 9R NFC Card on any NFC-enabled smartphone—your
              profile pops up instantly! Share contact info effortlessly. No
              apps, no hassle.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
